import { FormCategoryInformation } from '@model';
import { Action } from '@ngrx/store';

export enum FormsActionTypes {

  LoadFormCategoriesData = '[FormCategories] Load',
  LoadFormCategoriesDataSuccess = '[FormCategories] Load success',
  LoadFormCategoriesDataFail = '[FormCategories] Load fail',
  }
  
  export class LoadFormCategories implements Action {
    readonly type = FormsActionTypes.LoadFormCategoriesData;
    constructor() {}
  }
  export class LoadFormCategoriesSuccess implements Action {
    readonly type = FormsActionTypes.LoadFormCategoriesDataSuccess;
    constructor(public payload: FormCategoryInformation) {}
  }
  export class LoadFormCategoriesFail implements Action {
    readonly type = FormsActionTypes.LoadFormCategoriesDataFail;
    constructor(public payload: any) {}
  }

  export type FormsActions =
  | LoadFormCategories
  | LoadFormCategoriesSuccess
  | LoadFormCategoriesFail;